<div class="seller-page">
  <h1>Mes proprio ({{dealerData.myOwners!.length}})</h1>
  <div class="buttons-section">
    <button mat-button (click)="goToProviderSearch()" class="cta-button"><mat-icon>search</mat-icon>Rechercher fournisseurs</button>
  </div>

  @if ((dealerData.myOwners == undefined ) || dealerData.myOwners!.length === 0 ) {
    <h6>
      <br />
      Aucun proprio
    </h6>
  }

  <app-dealers
    [fetchingResults]="(fetchingResults$ | async)!"
    [dealers]="dealerData.myOwners"
    >
  </app-dealers>

</div>